import { createFileRoute } from '@tanstack/react-router';

import { ReferralPage, referralSearchSchema } from '@/pages/referral';

export const Route = createFileRoute('/referral')({
    validateSearch: referralSearchSchema,
    component: ReferralRoute,
});

function ReferralRoute() {
    const { signUpData } = Route.useSearch();
    return <ReferralPage signUpData={signUpData} />;
}
